/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Email_WordsInputs */

const en_us2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email account login`)
};

const pt_br2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email conta login`)
};

const es_419_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`correo email cuenta login`)
};

const pt_pt2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email conta login`)
};

const fr_fr2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email courriel compte connexion`)
};

const de_de2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email e-mail konto login anmeldung`)
};

const it_it2_search_field_email_words = /** @type {(inputs: Search_Field_Email_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email account accesso login`)
};

/**
* | output |
* | --- |
* | "email account login" |
*
* @param {Search_Field_Email_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_email_words = /** @type {((inputs?: Search_Field_Email_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Email_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_email_words(inputs)
	if (locale === "es-419") return es_419_search_field_email_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_email_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_email_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_email_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_email_words(inputs)
	return en_us2_search_field_email_words(inputs)
});
export { search_field_email_words as "search.field_email_words" }